import type { RealMachinesDatabase } from '@/db/database'
import { getDatabase } from '@/db/database'
import { executeDatabaseOperation } from '@/db/errors'
import { auditLogSchema } from '@/db/schemas'
import type { AuditLog, AuditableEntity } from '@/db/types'

export class AuditLogRepository {
  constructor(private readonly database: RealMachinesDatabase = getDatabase()) {}

  async listForEntity(
    entityType: AuditableEntity,
    entityId: string,
    limit = 100,
  ): Promise<AuditLog[]> {
    return executeDatabaseOperation('consultar auditoria', async () => {
      const records = await this.database.auditLogs
        .where('[entityType+entityId]')
        .equals([entityType, entityId])
        .reverse()
        .limit(Math.min(Math.max(limit, 1), 200))
        .toArray()
      return records.map((record) => auditLogSchema.parse(record))
    })
  }
}
